'use strict';

export default function UrlValidationService() {
  var URL_REGEX = /^(https?:)?\/\/.+\..+/;

  return {
    isValid: isValid
  };

  function isValid(url) {
    return URL_REGEX.test(url);
  }
}

UrlValidationService.$inject = [];
